const messages = {
  fleetWithOptions:
    "Ne možete izabrati flotu ako ste izabrali opcije",
  addProduct: "Vaš proizvod je dodat u korpu.",
  addProducts: "Vaši proizvodi su dodati u korpu.",
  profileSaved: "Podaci vašeg profila su sačuvani",
  canAddProduct: "Nemate dovoljno poena.",
  customerNumberSaved: "Broj kupca sačuvan",
  customerNumberExist: "Broj kupca dostupan",
  complaintForm: "Vaš zahtev je prihvaćen. Molimo sačekajte odgovor",
  openHourSaved: "Radno vreme je sačuvano",
  changeParentId:
    "Ne možete menjati podružnicu sa većim brojem kupca ako ima podređene podružnice.",
  requestSent: "Zahtev je poslat",
  completeProfileRequired:
    "Morate popuniti vaš profil 100% da biste mogli nastaviti sa kupovinama u shopu.",
  accessDenied: "Pristup odbijen",
  incomplete_address: "Adresa je nepotpuna. Molimo proverite",
  waitMoment: "Sačekajte trenutak",
  downloadFinished: "Preuzimanje završeno",
  selectOneField: "Izaberite jedno polje",
  noVoucher: "Vaučer nije pronađen",
  cannotAddCsNumber: "Ne možete dodati broj kupca",
  messagesDeletedSuccess: "Poruke su obrisane.",
  messagesDeletedError: "Brisanje poruka nije uspelo.",
  fillProfile: "Popunite profil da biste mogli preuzeti certifikat,",
  favoriteAdded: "Dodato u omiljene.",
  favoriteRemoved: "Uklonjeno iz omiljenih.",
};

export default {
  messages,
};
